// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/tailwindcss/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/@ionic/react/css/core.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Geist-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Geist-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Geist-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Geist-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Geist-RegularItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/Geist-RegularItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/GeistMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/GeistMono-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/GeistMono-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/GeistMono-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/GeistMono-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/GeistMono-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/fonts/helvetica.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/fonts/helvetica.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/fonts/ManufacturingConsent-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./assets/fonts/Gambarino-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./assets/fonts/Gambarino-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./assets/images/lolla24.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./assets/images/BullsBarclay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./assets/images/BullsBarclayGradient.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;
@tailwind backgrounds;
@tailwind effects;
/* Core CSS required for Ionic components to work properly */

/* Basic CSS for apps built with Ionic
@import '@ionic/react/css/normalize.css';
@import '@ionic/react/css/structure.css';
@import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out
@import '@ionic/react/css/padding.css';
@import '@ionic/react/css/float-elements.css';
@import '@ionic/react/css/text-alignment.css';
@import '@ionic/react/css/text-transformation.css';
@import '@ionic/react/css/flex-utils.css';
@import '@ionic/react/css/display.css';


/*import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';*/


@font-face {
    font-family: 'Geist';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'GeistBold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: 700;
    font-style: bold;
}

@font-face {
    font-family: 'GeistItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'GeistMono';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'GeistMono';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
    font-weight: normal;
    font-style: bold;
}

@font-face {
    font-family: 'GeistMono';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('truetype');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'Helvetica';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff'),
         url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Blackletter';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Gambarino';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1 {
  font-family: 'Geist';
}



.Splash{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-size: cover;        /* Ensures the image scales proportionally */
  background-position: center;   /* Centers the image */
  background-repeat: no-repeat;  /* Prevents tiling */
  height: 100vh;                 /* Ensures full viewport height */
  width: 100vw;                  /* Ensures full viewport width */
  overflow: hidden;              /* Prevents scrolling issues */
}

.SplashMobile{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-size: cover;        /* Ensures the image scales proportionally */
  background-position: right;   /* Centers the image */
  background-repeat: no-repeat;  /* Prevents tiling */
  height: 100vh;                 /* Ensures full viewport height */
  width: 100vw;                  /* Ensures full viewport width */
  overflow: hidden;              /* Prevents scrolling issues */
}

.BullsBarclay{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-size: cover;        /* Ensures the image scales proportionally */
  background-position: center;   /* Centers the image */
  background-repeat: no-repeat;  /* Prevents tiling */
  height: auto;                 /* Ensures full viewport height */
  width: 100vw;                  /* Ensures full viewport width */
  overflow: hidden;              /* Prevents scrolling issues */
}
.BullsBarclayGradient{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: cover;        /* Ensures the image scales proportionally */
  background-position: center;   /* Centers the image */
  background-repeat: no-repeat;  /* Prevents tiling */
  height: auto;                 /* Ensures full viewport height */
  width: 100vw;                  /* Ensures full viewport width */
  overflow: hidden;              /* Prevents scrolling issues */
}

body {
  margin: 0;
  background-color: #FCF9F8; /*f4fff7; #fffded;*/
  font-family: sans-serif;
  overflow-x: hidden;
}

.scrollCue {
  display: flex;
  justify-content: center;
  align-items: center;
  /* optional: keep it clickable without selecting */
  -webkit-user-select: none;
          user-select: none;
}

.scrollCue__arrow {
  transform: translateY(0);
  animation: scroll-bounce 2.35s ease-in-out infinite;
  will-change: transform, opacity;
  opacity: 0.95;
}

/* “downward hint” bounce */
@keyframes scroll-bounce {
  0%   { transform: translateY(-80px);    opacity: 0.85; }

  50% { transform: translateY(125px); opacity: 1; }

  100% { transform: translateY(-80px);    opacity: 0.85; }
}

/* respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .scrollCue__arrow {
    animation: none;
  }
}


.card {
  position: sticky;
  top: 0;
  color: black;
  top-padding: 5px;
  padding: 30px;
  margin-bottom: 0px;
}

.full-height-row {
  min-height: 100vh;   /* or height: 100vh; */
  display: flex;       /* optional, but nice for centering */
  align-items: center; /* vertical center */
}
:root{
  --ring: #5fba8b;
  --ringW: 3px; /* thickness */
}

/* ===== Regular inputs: ring only ===== */
input, textarea, select {
  outline: none;
}

input:focus,
input:focus-visible,
textarea:focus,
textarea:focus-visible,
select:focus,
select:focus-visible {
  outline: none !important;
  box-shadow: 0 0 0 var(--ringW) var(--ring) !important;
  border-color: transparent !important; /* optional, removes double-edge */
}

/* ===== Phone input: ring on wrapper only ===== */
.react-tel-input {
  border-radius: 30px; /* match your pill */
}

.react-tel-input:focus-within {
  box-shadow: 0 0 0 var(--ringW) var(--ring) !important;
  border-radius: 30px;
}

/* Kill inner borders on focus so you don't get “double thickness” */
.react-tel-input:focus-within .form-control,
.react-tel-input:focus-within .flag-dropdown {
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Keep the divider from showing through */
.react-tel-input:focus-within .flag-dropdown {
  border-right-color: none !important;
  box-shadow: 0 0 0 var(--ringW) var(--ring) !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;AACnB,qBAAqB;AACrB,iBAAiB;AACjB,4DAA4D;;AAG5D;;;;;;;;;;;;;;;;;0CAiB0C;;;AAG1C;IACI,oBAAoB;IACpB;mEAC+D;IAC/D,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB;mEAC4D;IAC5D,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B;mEACqE;IACrE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB;mEACmE;IACnE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB;mEACgE;IAChE,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB;oEACkE;IAClE,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB;oEAC2D;IAC3D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gEAA8E;IAC9E,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB;+DAC8D;IAC9D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;;;AAIA;EACE,0DAAoD;EACpD,sBAAsB,SAAS,4CAA4C;EAC3E,2BAA2B,IAAI,sBAAsB;EACrD,4BAA4B,GAAG,oBAAoB;EACnD,aAAa,kBAAkB,iCAAiC;EAChE,YAAY,mBAAmB,gCAAgC;EAC/D,gBAAgB,eAAe,8BAA8B;AAC/D;;AAEA;EACE,0DAAoD;EACpD,sBAAsB,SAAS,4CAA4C;EAC3E,0BAA0B,IAAI,sBAAsB;EACpD,4BAA4B,GAAG,oBAAoB;EACnD,aAAa,kBAAkB,iCAAiC;EAChE,YAAY,mBAAmB,gCAAgC;EAC/D,gBAAgB,eAAe,8BAA8B;AAC/D;;AAEA;EACE,0DAAyD;EACzD,sBAAsB,SAAS,4CAA4C;EAC3E,2BAA2B,IAAI,sBAAsB;EACrD,4BAA4B,GAAG,oBAAoB;EACnD,YAAY,kBAAkB,iCAAiC;EAC/D,YAAY,mBAAmB,gCAAgC;EAC/D,gBAAgB,eAAe,8BAA8B;AAC/D;AACA;EACE,0DAAiE;EACjE,sBAAsB,SAAS,4CAA4C;EAC3E,2BAA2B,IAAI,sBAAsB;EACrD,4BAA4B,GAAG,oBAAoB;EACnD,YAAY,kBAAkB,iCAAiC;EAC/D,YAAY,mBAAmB,gCAAgC;EAC/D,gBAAgB,eAAe,8BAA8B;AAC/D;;AAEA;EACE,SAAS;EACT,yBAAyB,EAAE,mBAAmB;EAC9C,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;EAClD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mDAAmD;EACnD,+BAA+B;EAC/B,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,OAAO,4BAA4B,KAAK,aAAa,EAAE;;EAEvD,MAAM,4BAA4B,EAAE,UAAU,EAAE;;EAEhD,OAAO,4BAA4B,KAAK,aAAa,EAAE;AACzD;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,IAAI,sBAAsB;EAC3C,aAAa,QAAQ,qCAAqC;EAC1D,mBAAmB,EAAE,oBAAoB;AAC3C;AACA;EACE,eAAe;EACf,YAAY,EAAE,cAAc;AAC9B;;AAEA,0CAA0C;AAC1C;EACE,aAAa;AACf;;AAEA;;;;;;EAME,wBAAwB;EACxB,qDAAqD;EACrD,oCAAoC,EAAE,kCAAkC;AAC1E;;AAEA,kDAAkD;AAClD;EACE,mBAAmB,EAAE,oBAAoB;AAC3C;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;;EAEE,oCAAoC;EACpC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;EACE,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE;aACW;AACb","sourcesContent":["@import \"tailwindcss\";\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@tailwind backgrounds;\n@tailwind effects;\n/* Core CSS required for Ionic components to work properly */\n@import '@ionic/react/css/core.css';\n\n/* Basic CSS for apps built with Ionic\n@import '@ionic/react/css/normalize.css';\n@import '@ionic/react/css/structure.css';\n@import '@ionic/react/css/typography.css';\n\n/* Optional CSS utils that can be commented out\n@import '@ionic/react/css/padding.css';\n@import '@ionic/react/css/float-elements.css';\n@import '@ionic/react/css/text-alignment.css';\n@import '@ionic/react/css/text-transformation.css';\n@import '@ionic/react/css/flex-utils.css';\n@import '@ionic/react/css/display.css';\n\n\n/*import '@ionic/react/css/core.css';\nimport '@ionic/react/css/normalize.css';\nimport '@ionic/react/css/structure.css';\nimport '@ionic/react/css/typography.css';*/\n\n\n@font-face {\n    font-family: 'Geist';\n    src: url('./assets/fonts/Geist-Regular.woff2') format('woff2'),\n         url('./assets/fonts/Geist-Regular.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'GeistBold';\n    src: url('./assets/fonts/Geist-Bold.woff2') format('woff2'),\n         url('./assets/fonts/Geist-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-style: bold;\n}\n\n@font-face {\n    font-family: 'GeistItalic';\n    src: url('./assets/fonts/Geist-RegularItalic.woff2') format('woff2'),\n         url('./assets/fonts/Geist-RegularItalic.ttf') format('truetype');\n    font-weight: normal;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'GeistMono';\n    src: url('./assets/fonts/GeistMono-Regular.woff2') format('woff2'),\n         url('./assets/fonts/GeistMono-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'GeistMono';\n    src: url('./assets/fonts/GeistMono-Bold.woff2') format('woff2'),\n         url('./assets/fonts/GeistMono-Bold.ttf') format('truetype');\n    font-weight: normal;\n    font-style: bold;\n}\n\n@font-face {\n    font-family: 'GeistMono';\n    src: url('./assets/fonts/GeistMono-Italic.woff2') format('woff2'),\n         url('./assets/fonts/GeistMono-Italic.ttf') format('truetype');\n    font-weight: normal;\n    font-style: italic;\n}\n\n@font-face {\n    font-family: 'Helvetica';\n    src: url('./assets/fonts/helvetica.woff') format('woff'),\n         url('./assets/fonts/helvetica.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Blackletter';\n    src: url('./assets/fonts/ManufacturingConsent-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Gambarino';\n    src: url('./assets/fonts/Gambarino-Regular.woff2') format('woff2'),\n    url('./assets/fonts/Gambarino-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh1 {\n  font-family: 'Geist';\n}\n\n\n\n.Splash{\n  background-image: url('./assets/images/lolla24.png');\n  background-size: cover;        /* Ensures the image scales proportionally */\n  background-position: center;   /* Centers the image */\n  background-repeat: no-repeat;  /* Prevents tiling */\n  height: 100vh;                 /* Ensures full viewport height */\n  width: 100vw;                  /* Ensures full viewport width */\n  overflow: hidden;              /* Prevents scrolling issues */\n}\n\n.SplashMobile{\n  background-image: url('./assets/images/lolla24.png');\n  background-size: cover;        /* Ensures the image scales proportionally */\n  background-position: right;   /* Centers the image */\n  background-repeat: no-repeat;  /* Prevents tiling */\n  height: 100vh;                 /* Ensures full viewport height */\n  width: 100vw;                  /* Ensures full viewport width */\n  overflow: hidden;              /* Prevents scrolling issues */\n}\n\n.BullsBarclay{\n  background-image: url('./assets/images/BullsBarclay.png');\n  background-size: cover;        /* Ensures the image scales proportionally */\n  background-position: center;   /* Centers the image */\n  background-repeat: no-repeat;  /* Prevents tiling */\n  height: auto;                 /* Ensures full viewport height */\n  width: 100vw;                  /* Ensures full viewport width */\n  overflow: hidden;              /* Prevents scrolling issues */\n}\n.BullsBarclayGradient{\n  background-image: url('./assets/images/BullsBarclayGradient.png');\n  background-size: cover;        /* Ensures the image scales proportionally */\n  background-position: center;   /* Centers the image */\n  background-repeat: no-repeat;  /* Prevents tiling */\n  height: auto;                 /* Ensures full viewport height */\n  width: 100vw;                  /* Ensures full viewport width */\n  overflow: hidden;              /* Prevents scrolling issues */\n}\n\nbody {\n  margin: 0;\n  background-color: #FCF9F8; /*f4fff7; #fffded;*/\n  font-family: sans-serif;\n  overflow-x: hidden;\n}\n\n.scrollCue {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* optional: keep it clickable without selecting */\n  user-select: none;\n}\n\n.scrollCue__arrow {\n  transform: translateY(0);\n  animation: scroll-bounce 2.35s ease-in-out infinite;\n  will-change: transform, opacity;\n  opacity: 0.95;\n}\n\n/* “downward hint” bounce */\n@keyframes scroll-bounce {\n  0%   { transform: translateY(-80px);    opacity: 0.85; }\n\n  50% { transform: translateY(125px); opacity: 1; }\n\n  100% { transform: translateY(-80px);    opacity: 0.85; }\n}\n\n/* respect reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .scrollCue__arrow {\n    animation: none;\n  }\n}\n\n\n.card {\n  position: sticky;\n  top: 0;\n  color: black;\n  top-padding: 5px;\n  padding: 30px;\n  margin-bottom: 0px;\n}\n\n.full-height-row {\n  min-height: 100vh;   /* or height: 100vh; */\n  display: flex;       /* optional, but nice for centering */\n  align-items: center; /* vertical center */\n}\n:root{\n  --ring: #5fba8b;\n  --ringW: 3px; /* thickness */\n}\n\n/* ===== Regular inputs: ring only ===== */\ninput, textarea, select {\n  outline: none;\n}\n\ninput:focus,\ninput:focus-visible,\ntextarea:focus,\ntextarea:focus-visible,\nselect:focus,\nselect:focus-visible {\n  outline: none !important;\n  box-shadow: 0 0 0 var(--ringW) var(--ring) !important;\n  border-color: transparent !important; /* optional, removes double-edge */\n}\n\n/* ===== Phone input: ring on wrapper only ===== */\n.react-tel-input {\n  border-radius: 30px; /* match your pill */\n}\n\n.react-tel-input:focus-within {\n  box-shadow: 0 0 0 var(--ringW) var(--ring) !important;\n  border-radius: 30px;\n}\n\n/* Kill inner borders on focus so you don't get “double thickness” */\n.react-tel-input:focus-within .form-control,\n.react-tel-input:focus-within .flag-dropdown {\n  border-color: transparent !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* Keep the divider from showing through */\n.react-tel-input:focus-within .flag-dropdown {\n  border-right-color: none !important;\n  box-shadow: 0 0 0 var(--ringW) var(--ring) !important;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
